import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import departmentService from "../../services/DepartmentService";

export const getDepartmentList = createAsyncThunk(
    "department/getDepartmentList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await departmentService.GetDepartmentList();
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to get department list"
            );
        }
    }
);

export const addDepartment = createAsyncThunk(
    "department/addDepartment",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await departmentService.AddDepartment(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to add department"
            );
        }
    }
);

export const updateDepartment = createAsyncThunk(
    "department/updateDepartment",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await departmentService.UpdateDepartment(payload);
            return response.data?.ResultSet || [];
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.Message ||
                error.message ||
                "Failed to update department"
            );
        }
    }
);

const initialState = {
    departments: [],
    loading: false,
    saving: false,
    error: null,
    success: false,
};

const departmentSlice = createSlice({
    name: "department",
    initialState,
    reducers: {
        clearDepartmentError: (state) => {
            state.error = null;
        },

        clearDepartmentSuccess: (state) => {
            state.success = false;
        },

        clearDepartments: (state) => {
            state.departments = [];
        }
    },

    extraReducers: (builder) => {
        builder

        // Get department list
        .addCase(
            getDepartmentList.pending,
            (state) => {
                state.loading = true;
                state.error = null;
            }
        )
        .addCase(
            getDepartmentList.fulfilled,
            (state, action) => {
                state.loading = false;
                state.departments = action.payload;
            }
        )
        .addCase(
            getDepartmentList.rejected,
            (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to load departments";
            }
        )

        // Add Department
        .addCase(addDepartment.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(addDepartment.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(addDepartment.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to add department";
        })

        // Update Department
        .addCase(updateDepartment.pending, (state) => {
            state.saving = true;
            state.error = null;
            state.success = false;
        })
        .addCase(updateDepartment.fulfilled, (state) => {
            state.saving = false;
            state.success = true;
        })
        .addCase(updateDepartment.rejected, (state, action) => {
            state.saving = false;
            state.error = action.payload || "Failed to update department";
        });
    }
});

export const {
    clearDepartmentError,
    clearDepartmentSuccess,
    clearDepartments
} = departmentSlice.actions;

export default departmentSlice.reducer;